export default "__VITE_ASSET__ee942050__"